import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "user-profile-edition",
  class: "center-card"
}

import { computed, toRefs } from 'vue'

  import UserProfileTabs from '@/components/User/UserProfileTabs.vue'
  import { AUTH_USER_STORE } from '@/store/constants'
  import { IUserProfile } from '@/types/user'
  import { useStore } from '@/use/useStore'

  interface Props {
    user: IUserProfile
    tab: string
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    user: null,
    tab: null
  },
  setup(__props: any) {

const props = __props as {
    user: IUserProfile
    tab: string
  }

  

  const store = useStore()

  const { user, tab } = toRefs(props)
  const tabs = ['PROFILE', 'ACCOUNT', 'PICTURE', 'PREFERENCES', 'SPORTS']
  const loading = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.USER_LOADING]
  )

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t(`user.PROFILE.${_unref(tab)}_EDITION`)), 1)
      ]),
      content: _withCtx(() => [
        _createVNode(UserProfileTabs, {
          tabs: tabs,
          selectedTab: _unref(tab),
          edition: true,
          disabled: _unref(loading)
        }, null, 8, ["selectedTab", "disabled"]),
        _createVNode(_component_router_view, { user: _unref(user) }, null, 8, ["user"])
      ]),
      _: 1
    })
  ]))
}
}

})